import * as React from 'react';
import styled from 'styled-components';

import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { AgCharts } from "ag-charts-react";
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { Event } from '@process-advisor/process-miner/api/events';

ModuleRegistry.registerModules([AllCommunityModule]);
ModuleRegistry.registerModules([AllEnterpriseModule]);

const Wrapper = styled.div`
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
    margin-left: 10px; 
    margin-right: 10px;
    background-color: white
`;

export function LifeCycle(){

    const [seriesData, setSeriesData] = React.useState([]);
    const [categoryData, setCategoryData] = React.useState([]);

    React.useEffect(() => {
        const listener = () => {
            updateGraph()
        }
        listener();
        apiProvider.on(Event.openLifecycleModalMulti, listener);

        return () => {
            apiProvider.off(Event.openLifecycleModalMulti, listener);
        };
    }, []);

    React.useEffect(() => {
        updateGraph()
    }, []);

    function updateGraph() {
        apiProvider.setTasksVisualizationFilter({filter: 0})
        apiProvider.setTasksVisualizationSource({source: 'tia'})
        apiProvider.tasksVisualization()

        let tSeriesData = apiProvider.getLifecycleSeries().sort((a, b) => b.sort - a.sort)
        let tCategoryData = apiProvider.getLifecycleCategory().sort()
        setCategoryData(tCategoryData)
        setSeriesData(tSeriesData)
        setOptions({data: tCategoryData, series: tSeriesData})
    }

    const [options, setOptions] = React.useState({
        data: categoryData,
        series: seriesData,
    });

    return (
        <Wrapper>
            <AgCharts options={options} />
        </Wrapper>
    );
};
